<template>
	<div class="container">
		<menuAdmin></menuAdmin>
		<div class="spinner-border" role="status" v-if="loading === true">
			<span class="sr-only">cargando...</span>
		</div>
		<div class="row">
			<div class="col-12 d-flex align-items-center justify-content-between">
				<button type="button" class="primary-btn" @click="exportExcel()">
					<i class="fa fa-download mr-1" aria-hidden="true"></i>
					Exportar Chat
				</button>

				<button type="button" class="primary-btn danger-btn" @click="deleteMessages()">
					<i class="fa fa-trash mr-1" aria-hidden="true"></i>
					Eliminar Mensajes
				</button>
			</div>
			<div class="col-12 m-0 p-0">
				<table class="table border rounded">
					<thead>
						<tr>
							<th scope="col">Usuario</th>
							<th scope="col">Mensaje</th>
							<th class="text-center" scope="col">Fecha</th>
							<th class="text-center" scope="col">Ocultar</th>
							<th class="text-center" scope="col">Fijar</th>
							<th class="text-center" scope="col">Eliminar</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="message in messages" :key="message.id">
							<th scope="row">
								{{ message.username }}
							</th>
							<td>{{ message.text }}</td>
							<td class="text-center">{{ $moment(message.fecha).fromNow() }}</td>
							<td class="text-center">
								<div class="custom-control custom-switch" @click="update(message)">
									<input type="checkbox" class="custom-control-input" :id="message.id"
										:checked="!message.visible" />
									<label class="custom-control-label" :class="{ opacity: message.visible}">
									</label>
								</div>
								<!-- <div v-if="!message.visible">
									<button type="button" class="btn btn-warning btn-sm" @click="guardaPalabra(message)"
										v-if="!message.banned">
										<i class="fa fa-ban" aria-hidden="true"></i>
									</button>
								</div> -->
							</td>
							<td class="text-center">
								<div class="custom-control custom-switch" @click="pinned(message)">
									<input type="checkbox" class="custom-control-input" :id="message.id"
										:checked="message.pinned" />
									<label class="custom-control-label" :class="{ opacity: !message.pinned }">
									</label>
								</div>
							</td>
							<td class="text-center">
								<button type="button" class="danger-icon-btn" @click="deleteItem(message.id)">
									<i class="fa fa-trash" aria-hidden="true"></i>
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>

import fire from "./../fire";
import menuAdmin from "../components/MenuAdmin";
import Swal from 'sweetalert2';
//import { read, writeFileXLSX } from "xlsx";
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
	name: "AdminChat",
	components: { menuAdmin },
	// eslint-disable-next-line vue/no-unused-components
	data() {
		return {
			messages: [],
			loading: false,
			texto: "",
			dataToExport: []
		};
	},
	methods: {
		deleteItem(id) {
			Swal.fire({
				title: "¿Estas seguro de que quieres eliminar el mensaje?",
				text: "No podrás revertir esta acción mas adelante",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				cancelButtonText: "Cancelar!",
				confirmButtonText: "Si, Eliminar!",
			}).then((result) => {
				if (result.isConfirmed) {
					let mensaje = fire
						.database()
						.ref("messages")
						.child(id);
					mensaje.remove()
						.then(() => {
							console.log('Objeto con id: ' + id + '  eliminaddo correctamente');
							Swal.fire({
								didOpen: () => {
									Swal.hideLoading();
								},
								title: 'Mensaje Eliminado',
								text: 'Se elimino el mensaje con éxito',
								icon: 'success',
								showConfirmButton: false,
								timer: 1000,
							}, function () {
								Swal.close();
							});
						})
						.catch((error) => {
							console.log(`Error: ${error}`)
						})
				}
			})
		},

		update(item) {
			let visible = null;
			console.log(item);
			if (item.visible == true) {
				visible = false;
			} else {
				visible = true;
			}
			fire.database().ref("messages/" + item.id).update(
				{
					visible: visible
				},
				function (error) {
					if (error) {
						console.log("update failed");
					} else {
						console.log("update successfully!");
					}
				}
			);
		},
		pinned(item) {
			let status = null;
			if (item.pinned == true) {
				status = false;
			} else {
				status = true;
			}
			fire.database().ref("messages/" + item.id).update(
				{
					pinned: status
				},
				function (error) {
					if (error) {
						console.log("pinned update failed");
					} else {
						console.log("pinned update successfully!");
					}
				}
			);
		},
		guardaPalabra(item) {
			const banned = item.banned ? false : true;
			console.log(banned)
			fire.database().ref("messages/" + item.id).update({ banned: banned });
			fire.database().ref("banned").push({ username: item.username });
		},
		cargaMensajes() {
			let viewMessage = this;
			const itemsRef = fire
				.database()
				.ref("messages")
				.limitToLast(200);
			this.loading = false;
			itemsRef.on("value", snapshot => {
				let data = snapshot.val();
				let messages = [];
				Object.keys(data).forEach(key => {
					messages.unshift({
						id: key,
						username: data[key].username,
						text: data[key].text,
						fecha: data[key].fecha,
						visible: data[key].visible,
						pinned: data[key].pinned,
						banned: data[key].banned
					});
				});
				viewMessage.messages = messages;
			});
		},
		deleteMessages() {
			Swal.fire({
				title: "¿Estas seguro de que quieres eliminar los mensajes?",
				text: "No podrás revertir esta acción mas adelante",
				icon: "warning",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
				cancelButtonText: "Cancelar!",
				confirmButtonText: "Si, Eliminar!",
			}).then((result) => {
				if (result.isConfirmed) {
					let collection = fire
						.database()
						.ref("messages");
					collection.remove()
						.then(() => {
							console.log('Mensajes eliminados correctamente');
							Swal.fire({
								didOpen: () => {
									Swal.hideLoading();
								},
								title: 'Mensajes eliminados',
								text: 'Se eliminaron los mensajes con éxito',
								icon: 'success',
								showConfirmButton: false,
								timer: 1000,
							}, function () {
								Swal.close();
							});
							this.messages = [];
							this.cargaMensajes();
						}).catch((error) => {
							console.log(`Error: ${error}`);
						})
				}
			})
		},
		exportExcel: function () {
			const dbRef = fire.database().ref();
			dbRef.child("messages").get().then((snapshot) => {
				if (snapshot.exists()) {

					let dataMessages = snapshot.val();
					let dataToExport = [];
					Object.keys(dataMessages).forEach(key => {
						dataToExport.push({
							Usuario: dataMessages[key].username,
							Mensaje: dataMessages[key].text
						});
					});

					this.dataToExport = dataToExport;
					console.log(dataToExport)

					let data = XLSX.utils.json_to_sheet(this.dataToExport)
					const workbook = XLSX.utils.book_new()
					const filename = 'export-messages'
					XLSX.utils.book_append_sheet(workbook, data, filename)
					XLSX.writeFile(workbook, `${filename}.xlsx`)
				} else {
					console.log("No data available");
				}
			}).catch((error) => {
				console.error(error);
			});
		}
	},
	mounted() {
		this.cargaMensajes();
	}
};
</script>
<style lang="scss">
.table {
	border-color: #ccc;

	tr {
		&:nth-child(even) {
			background: #f4f4f4;
		}

		&:nth-child(odd) {
			background: #fff;
		}

		th,
		td {
			.btn-danger {
				position: relative;
			}
		}
	}

	.message {
		word-break: break-all;
	}

	.fecha {
		font-style: italic;
		color: #ccc;
	}
}
</style>